/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Page_Feature_IosInputs */

const en_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Plus Advanced Features
Upgrade your focus experience!

[%key_id:752478212%]

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of subscription status.`)
};

const ar_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# ميزات متقدمة إضافية
قم بترقية تجربة التركيز الخاصة بك!

[%key_id:752478212%]

- يشمل مستخدمو نسخة المحترفين مستخدمي iOS الذين دفعوا مقابل تنزيل Forest من متجر آبل، بالإضافة إلى مستخدمي آندرويد الذين قاموا بفتح نسخة المحترفين. 
 - بالنسبة لمستخدمي نسخة المحترفين، سيتم الاحتفاظ بجميع ميزات وفوائد نسخة المحترفين التي تم فتحها في الأصل مدى الحياة، بغض النظر عن حالة الاشتراك.`)
};

const de_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Plus Erweiterte Funktionen
Verbessern Sie Ihr Fokus-Erlebnis!

[%key_id:752478212%]

- Pro-Nutzer sind iOS-Nutzer, die für den Download von Forest aus dem App Store bezahlt haben, sowie Android-Nutzer, die die Pro-Version freigeschaltet haben. 
- Für Pro-Nutzer bleiben alle Pro-Funktionen und Vorteile, die ursprünglich freigeschaltet wurden, lebenslang erhalten, unabhängig vom Abonnementstatus.`)
};

const es_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Funciones avanzadas de Plus
Mejora tu experiencia de concentración

[%key_id:752478212%]

- Entre los usuarios de Pro se incluyen los usuarios de iOS que hayan pagado para descargar Forest de la App Store, así como los usuarios de Android que hayan desbloqueado la versión Pro. 
- Para los usuarios de Pro, todas las características y beneficios Pro que fueron desbloqueados originalmente se mantendrán de por vida, independientemente del estado de suscripción.`)
};

const fr_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Fonctionnalités Avancées Plus
Améliorez votre expérience de concentration!

[%key_id:752478212%]

- Les utilisateurs Pro comprennent les utilisateurs iOS qui ont payé pour télécharger Forest depuis l'App Store, ainsi que les utilisateurs Android qui ont débloqué la version Pro.
- Pour les utilisateurs Pro, toutes les fonctionnalités et avantages Pro initialement débloqués sont conservés à vie, quel que soit le statut de l'abonnement.`)
};

const it_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Funzionalità Plus Avanzate
Migliora la tua esperienza di concentrazione!

[%key_id:752478212%]

- Gli Utenti Pro includono gli utenti iOS che hanno pagato per scaricare Forest dall'App Store, così come gli utenti Android che hanno sbloccato la versione Pro. 
- Per gli Utenti Pro, tutte le funzionalità e i vantaggi Pro originariamente sbloccati verranno mantenuti a vita, indipendentemente dallo stato dell'abbonamento.`)
};

const ja_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Plusの高度な機能
集中力を向上させよう！

[%key_id:752478212%]

- プロユーザーには、App StoreからForestを有料でダウンロードしたiOSユーザーと、プロ版をアンロックしたAndroidユーザーが含まれます。 
- プロユーザーの場合、サブスクリプションのステータスに関係なく、最初にアンロックされたすべてのプロ機能と特典は生涯ご利用いただけます。`)
};

const ko_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Plus 고급 기능
집중 경험을 업그레이드하세요!

[%key_id:752478212%]

- Pro 사용자에는 앱 스토어에서 유료로 Forest를 다운로드한 iOS 사용자와 Pro 버전을 구입한 Android 사용자가 포함됩니다. 
- Pro 사용자의 경우, 기존에 구입한 모든 Pro 기능 및 혜택은 구독 상태와 관계없이 평생 유지됩니다.`)
};

const pt_br_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Funcionalidades avançadas Plus
Eleve o nível da sua experiência de foco!

[%key_id:752478212%]

- Usuários Pro incluem os usuários iOS que pagaram para baixar o Forest na App Store, assim como os usuários Android que desbloquearam a versão Pro.
- Para os usuários Pro, todas as funcionalidades e benefícios Pro que foram originalmente desbloqueados serão mantidos para sempre, independentemente do status da assinatura.`)
};

const ru_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Продвинутые Plus-функции
Улучшите свою сосредоточенность!

[%key_id:752478212%]

- К пользователям Pro относятся пользователи iOS, оплатившие скачивание Forest из App Store, а также пользователи Android, разблокировавшие версию Pro. 
- Для пользователей Pro все функции и преимущества Pro, которые были изначально разблокированы, сохраняются навсегда, независимо от статуса подписки.`)
};

const th_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# คุณสมบัติขั้นสูงของ Plus
อัปเกรดประสบการณ์การโฟกัสของคุณ!

[%key_id:752478212%]

- ผู้ใช้โปรได้แก่ ผู้ใช้ iOS ที่ชำระเงินเพื่อดาวน์โหลด Forest จาก App Store รวมถึงผู้ใช้ Android ที่ปลดล็อกเวอร์ชันโปรแล้ว
- สำหรับผู้ใช้โปร คุณสมบัติและสิทธิประโยชน์โปรทั้งหมดที่ถูกปลดล็อกตั้งแต่เดิมจะคงอยู่ตลอดชีพ ไม่ว่าสถานะการสมัครสมาชิกจะเป็นแบบใดก็ตาม`)
};

const tr_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Plus Gelişmiş Özellikler
Odaklanma deneyimini yükselt!

[%key_id:752478212%]

- Pro kullanıcıları, Forest'ı App Store'dan indirmek için ödeme yapan iOS kullanıcılarının yanı sıra Pro sürümünün kilidini açan Android kullanıcılarını da içerir. 
- Pro kullanıcılar için başlangıçta kilidi açılmış olan tüm Pro özellikleri ve avantajları, abonelik durumundan bağımsız olarak ömür boyu korunacaktır.`)
};

const zh_cn_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Plus 进阶功能
全面升级你的专注体验！

[%key_id:752478212%]

- 专业版用户包含 iOS 有在 App Store 付费下载过 Forest 或是 Android 有解锁专业版的用户
- 专业版用户原先解锁专业版的功能和权益都将终身保留，无论是否有购买 Plus 会员`)
};

const zh_tw_subscription_detail_page_feature_ios = /** @type {(inputs: Subscription_Detail_Page_Feature_IosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 3
---

# Plus 進階功能
全面升級你的專注體驗！

[%key_id:752478212%]

- 專業版用戶包含 iOS 有在 App Store 付費下載過 Forest 或是 Android 有解鎖專業版的用戶
- 專業版用戶原先解鎖專業版的功能和權益都將終身保留，無論是否有訂閱`)
};

/**
* | output |
* | --- |
* | "--- section: 3 --- # Plus Advanced Features Upgrade your focus experience! [%key_id:752478212%] - Pro users include iOS users who have paid to download Fores..." |
*
* @param {Subscription_Detail_Page_Feature_IosInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_page_feature_ios = /** @type {((inputs?: Subscription_Detail_Page_Feature_IosInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Page_Feature_IosInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_page_feature_ios(inputs)
	if (locale === "ar") return ar_subscription_detail_page_feature_ios(inputs)
	if (locale === "de") return de_subscription_detail_page_feature_ios(inputs)
	if (locale === "es") return es_subscription_detail_page_feature_ios(inputs)
	if (locale === "fr") return fr_subscription_detail_page_feature_ios(inputs)
	if (locale === "it") return it_subscription_detail_page_feature_ios(inputs)
	if (locale === "ja") return ja_subscription_detail_page_feature_ios(inputs)
	if (locale === "ko") return ko_subscription_detail_page_feature_ios(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_page_feature_ios(inputs)
	if (locale === "ru") return ru_subscription_detail_page_feature_ios(inputs)
	if (locale === "th") return th_subscription_detail_page_feature_ios(inputs)
	if (locale === "tr") return tr_subscription_detail_page_feature_ios(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_page_feature_ios(inputs)
	return zh_tw_subscription_detail_page_feature_ios(inputs)
});